import { CoreDataDictionaryViewsSharedKeyName } from './name';
import { postDataDictionaryShareView } from '@api';
import { updateCoreDataDictionaryViewsSyncSlice } from '../update';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataDictionaryViewsSharedKeyAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateCoreDataDictionaryViewsSyncSlice.syncActionCreator({
					id: request.viewId,
					sharedKey: response.sharedViewKey
				})
		]
	},
	name: CoreDataDictionaryViewsSharedKeyName,
	receive: true,
	request: true,
	requestHandler: postDataDictionaryShareView,
	yieldType: SagaYieldType.Every
});
